module.exports = __webpack_public_path__ + "static/media/4.62a52c8e.jpg";